export { default } from "./SponsorMultiAdv";
